import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-down-right', 'IconArrowDownRight', [
  ['path', { d: 'M7 7l10 10', key: 'svg-0' }],
  ['path', { d: 'M17 8l0 9l-9 0', key: 'svg-1' }],
]);
